/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
@Component({
  selector: 'job-service-territory-tooltip',
  templateUrl: './job-service-territory-tooltip.component.html',
  styleUrls: ['./job-service-territory-tooltip.component.scss']
})
export class JobServiceTerritoryToolTipComponent implements OnInit, OnChanges {
  @Input() options: any = {};
  @Output() closetoolTip: EventEmitter<any> = new EventEmitter<any>();
  territory: any = {};
  currentTerritory: any;
  conflictedTerritory: any;
  conflictedTeam: any = [];

  constructor(private jobService: JobsService,
              private utilityService: UtilityService
  ){}


  ngOnInit(): void {}

  getTerritoryConflict(JobId: any): void{
    this.jobService.getTerritoryConflicts(JobId).subscribe((response: any)=>{
      this.territory = response?.data;
      this.setCurrentAndConflictedTerritory(this.territory);
    })
  }

  setCurrentAndConflictedTerritory(data: any): void{
    this.currentTerritory = data?.current_territory ?? data?.matched_territory;
    this.conflictedTeam = data?.current_territory?.territory?.teams?.filter((data: any)=> !this.utilityService.isEmptyOrUndefined(data))
    this.conflictedTerritory = data?.conflict_territory;
  }

  closeTooltip = (): any => {
    this.closetoolTip.emit(false);
  };

  assignTerritory(territory: any): void{
    this.closetoolTip.emit({territory: territory?.territory_uid});
  }

  ngOnChanges(changes: SimpleChanges): void{
    if('options' in changes){
      this.options = changes?.options?.currentValue;
      if(this.options?.mode === 'new'){
        this.territory = this.options?.territory;
        this.setCurrentAndConflictedTerritory(this.territory);
      }else{
        this.getTerritoryConflict(this.options?.jobId);
      }
    }
  }
}


